import React, { useState, useEffect } from 'react';
import './section7.css';
import phoneIcon from '../../assets/icons-footer/phone-footer.svg';
import emailFooterIcon from '../../assets/icons-footer/e-mail-footer.svg';
import selo from '../../assets/selo/selo3.svg';
import CardSection1 from '../Header/cardSection1'; 

const Footer = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isOpen, setIsOpen] = useState(false);
  const [showHotelCard, setShowHotelCard] = useState(false); 

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleLinks = () => setIsOpen(!isOpen);

  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Coluna 1 */}
        <div className="footer-column">
          <h3>Grupo Total</h3>
          <p>
            Inovamos no associativismo no Brasil, conectando uma rede sólida e humana.
            Com tecnologia, inteligência de mercado e profissionais qualificados,
            impactamos a vida de mais de 37 milhões de brasileiros. <strong>Venha ser Total</strong>!
          </p>

          <div className="footer-contact">
            <div className="contact-item">
              <a href="https://wa.me/5516991430898" target="_blank" rel="noopener noreferrer">
                <img src={phoneIcon} alt="Telefone" className="footer-icon" />
                <span className="whatsapp-text">(16) 99143-0898</span>
              </a>
            </div>
            <div className="contact-item">
              <img src={emailFooterIcon} alt="E-mail" className="footer-icon" />
              <a href="mailto:comercial.mkt@drogariatotal.com.br">comercial.mkt@drogariatotal.com.br</a>
            </div>
            <div className="footer-address">
              Av Itatiaia, 390 | Alto da Boa Vista<br />
              Ribeirão Preto - SP
            </div>
          </div>
        </div>

        {/* Coluna 2 — Links */}
        <div className="footer-column">
          {isMobile ? (
            <>
              <button className="footer-toggle-button" onClick={toggleLinks}>
                Links {isOpen ? '▲' : '▼'}
              </button>
              {isOpen && (
                <ul className="footer-links">
                  <li><a href="https://solar.totaldrogaria.com.br">ÁREA DO ASSOCIADO</a></li>
                  <li><a href="https://euvou.events/42feiradenegocios2025@associadoscessionariosefranqueado/login">QUERO PARTICIPAR</a></li>
                </ul>
              )}
              <img src={selo} alt="Selo Grupo Total" className="footer-selo" />
            </>
          ) : (
            <>
              <h3>Links</h3>
              <ul className="footer-links">
                <li><a href="https://solar.totaldrogaria.com.br">ÁREA DO ASSOCIADO</a></li>
                <li><a href="https://euvou.events/42feiradenegocios2025@associadoscessionariosefranqueado">QUERO PARTICIPAR</a></li>
              </ul>
              <img src={selo} alt="Selo Grupo Total" className="footer-selo" />
            </>
          )}
        </div>
      </div>

      <div className="footer-bottom">
        <nav>
          <a href="https://solar.totaldrogaria.com.br/login" target="_blank" rel="noopener noreferrer">
            Área do Associado
          </a>
          <a href="#link2">Programação</a>
          <a href="#link3">Como Chegar</a>
          <a href="#link8">Parceiros</a>
          

          {/* Botão Hotéis substituindo o <a> */}
          <button
            className="footer-hotel-button"
            onClick={() => setShowHotelCard(true)}
          >
            Hotéis
          </button>
        </nav>
        <p>© 2025 Grupo Total. Todos os direitos reservados.</p>
      </div>

      {/* Card modal de hotéis */}
      {showHotelCard && <CardSection1 onClose={() => setShowHotelCard(false)} />}
    </footer>
  );
};

export default Footer;
